import { render, staticRenderFns } from "./ForbiddenDialog.vue?vue&type=template&id=570dc0f0"
import script from "./ForbiddenDialog.vue?vue&type=script&lang=js"
export * from "./ForbiddenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports